import classNames from 'classnames';
import React, { FC } from 'react';
import { commonUtils } from '../../../redux/_common';
import { IEntry } from 'redux/app/vessel/types';
import { vesselUtils } from 'redux/app/vessel';

interface IDatePaginationProps {
    logs: any[];
    setSelectedLog: (log: any[] | any, date?: string) => void;
    index: number;
    setIndex: (index: number) => void;
    entry?: IEntry;
}

const getButtonTitle = (log: any) => {
    if (!log) return '';
    let title = '';
    if (log?.intlDateLineRecord) {
        title = 'Intl Date Line Record.';
    }
    if (log?.data?.isMissedEntry) {
        title += 'Missed Entry';
    }

    // append date
    const date = commonUtils.formatSelectedDate(log?.selectedDate);
    title += `  ${date}`;
    return title;
};

function getHalfDayVisible(id: string) {
    const daysWrapperElm = document.getElementById('daysWrapper');
    const dayElm = document.getElementById(id);

    const daysWrapperWidth =
        daysWrapperElm?.getBoundingClientRect()?.width || 0;
    const dayWidth = dayElm?.getBoundingClientRect()?.width || 0;

    // 8 is for style class 'gap-x-2'
    const halfDayVisible = Math.floor(daysWrapperWidth / (dayWidth + 8) / 2);

    return halfDayVisible;
}

const DatePagination: FC<IDatePaginationProps> = (props) => {
    const { logs, setSelectedLog, entry, index, setIndex } = props;
    if (!logs || !logs.length) return null;

    const allLogIds = logs?.map(
        (log) => log?.intlDateLineRecord + '-' + log?.selectedDate
    );
    const uniqueLogs: any[] = [];
    const uniqueLogIds = Array.from(new Set(allLogIds));
    const recordOfLog: Record<string, any> = {};
    logs?.forEach((log) => {
        recordOfLog[log?.intlDateLineRecord + '-' + log?.selectedDate] = log;
    });
    uniqueLogIds?.forEach((logId) => {
        uniqueLogs.push(recordOfLog[logId]);
    });

    return (
        <div className="flex items-center h-full bg-white">
            <button
                onClick={() => {
                    if (index !== undefined) {
                        if (index - 1 >= 0) {
                            const idx = index - 1;

                            let scrollToIndex =
                                idx - getHalfDayVisible(`singleDayLogs_${idx}`);
                            while (scrollToIndex < 0) {
                                scrollToIndex += 1;
                            }
                            commonUtils.smoothScrollToLink(
                                `singleDayLogs_${scrollToIndex}`
                            );

                            const modelname = logs[idx]?.modelName;
                            if (modelname === 'permitLogs') {
                                // If logs are permitLogs, we expect an array of logs
                                const date = logs[idx]?.selectedDate;
                                setSelectedLog(logs, date);
                            } else {
                                setIndex(idx);
                                setSelectedLog(logs[idx]);
                            }
                        }
                    }
                }}
                className="flex items-center justify-center min-w-[20px] border border-ws_input_border self-stretch border-r-0 rounded-l-md outline-none"
            >
                <span className="bp3-icon bp3-icon-chevron-left text-xl text-[#9E9E9E]" />
            </button>
            <section
                id="daysWrapper"
                className="flex items-center self-stretch flex-1 p-1 overflow-x-scroll border border-ws_input_border gap-x-2 ws-scroll"
            >
                {
                    // logs?.map((singleDayLogs, i) => {
                    //   if (!singleDayLogs || !Array.isArray(singleDayLogs) || (singleDayLogs.length === 0)) {
                    //       console.log('No log found');
                    //       return null;
                    //   }
                    // const log = singleDayLogs[0];
                    uniqueLogs?.map((log, i) => {
                        if (!log) return null;
                        const date = commonUtils.getUtcTime(
                            vesselUtils.getDate(log, entry?.type)
                        );
                        return (
                            <div
                                key={log.logId || log._id}
                                id={`singleDayLogs_${i}`}
                                className="relative"
                            >
                                <button
                                    className={classNames(
                                        'flex flex-col text-gray-800 items-center justify-center min-w-[40px] min-h-[40px] rounded-full font-medium',
                                        {
                                            'hover:bg-gray-300 hover:text-gray-800':
                                                index !== i &&
                                                !log?.intlDateLineRecord &&
                                                !log?.data?.isMissedEntry,
                                            'bg-[#D8E6FF] hover:bg-[#D8E6FF]':
                                                index === i &&
                                                !log?.intlDateLineRecord &&
                                                !log?.data?.isMissedEntry,

                                            // intlDateLineRecord is true then show background color in red
                                            'bg-red-300 hover:bg-red-400 dark:text-gray-700':
                                                log?.intlDateLineRecord &&
                                                index !== i,
                                            // on select of intlDateLineRecord show background color in darker red
                                            'bg-red-600 text-white':
                                                log?.intlDateLineRecord &&
                                                index === i,

                                            // if log is missed entry then show background color in yellow
                                            'bg-yellow-200 dark:text-gray-700 hover:bg-yellow-400':
                                                log?.data?.isMissedEntry &&
                                                index !== i,
                                            // on select of missed entry show background color in darker yellow
                                            'bg-yellow-600 text-white hover:bg-yellow-700':
                                                log?.data?.isMissedEntry &&
                                                index === i,
                                        }
                                    )}
                                    title={getButtonTitle(log)}
                                    onClick={() => {
                                        setIndex(i);
                                        // setSelectedLog(singleDayLogs);
                                        const modelname = log?.modelName;
                                        console.log({
                                            modelname,
                                        });
                                        if (modelname === 'permitLogs') {
                                            // If logs are permitLogs, we expect an array of logs
                                            const date = log?.selectedDate;
                                            console.log(
                                                {
                                                    date,
                                                    log,
                                                },
                                                'from date selector'
                                            );
                                            setSelectedLog(logs, date);
                                        } else {
                                            // For other types of logs, we can just set the first log
                                            setSelectedLog(log);
                                        }
                                    }}
                                >
                                    <span className="text-[10px]">
                                        {date.format('DD')}
                                    </span>
                                    <span className="text-xs opacity-70">
                                        {date.format('MMM')}
                                    </span>
                                </button>
                                {/* {
                        entry && entry.type !== 'LOG'?
                          <span
                            className='absolute text-[10px] w-4 h-4 rounded-full flex items-center justify-center -top-1 -right-1 bg-[#D8E6FF] text-black shadow-md'
                          >
                            {
                              singleDayLogs?.length
                            }
                          </span>
                        : null
                      } */}
                            </div>
                        );
                    })
                }
            </section>
            <button
                onClick={() => {
                    if (index !== undefined) {
                        if (logs.length > index + 1) {
                            const idx = index + 1;

                            let scrollToIndex =
                                idx + getHalfDayVisible(`singleDayLogs_${idx}`);
                            while (scrollToIndex >= logs.length) {
                                scrollToIndex -= 1;
                            }
                            commonUtils.smoothScrollToLink(
                                `singleDayLogs_${scrollToIndex}`
                            );
                            const modelname = logs[idx]?.modelName;
                            if (modelname === 'permitLogs') {
                                // If logs are permitLogs, we expect an array of logs
                                const date = logs[idx]?.selectedDate;
                                setSelectedLog(logs, date);
                            } else {
                                setIndex(idx);
                                setSelectedLog(logs[idx]);
                            }
                        }
                    }
                }}
                className="flex items-center justify-center min-w-[20px] border border-ws_input_border self-stretch border-l-0 rounded-r-md outline-none"
            >
                <span className="bp3-icon bp3-icon-chevron-right text-xl text-[#9E9E9E]" />
            </button>
        </div>
    );
};

export default DatePagination;
